function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "griglia",
  display: "none"
}, /*#__PURE__*/React.createElement("g", {
  display: "inline"
}, /*#__PURE__*/React.createElement("rect", {
  x: 307.5,
  y: 307.5,
  fill: "none",
  stroke: "#E6007E",
  strokeWidth: 0.0461,
  strokeMiterlimit: 10,
  width: 1040,
  height: 1040
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 507.5,
  y: 507.5,
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0461,
  strokeMiterlimit: 10,
  width: 640,
  height: 640
}), /*#__PURE__*/React.createElement("rect", {
  x: 427.5,
  y: 427.5,
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0461,
  strokeMiterlimit: 10,
  width: 800,
  height: 800
}), /*#__PURE__*/React.createElement("rect", {
  x: 347.5,
  y: 347.5,
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0461,
  strokeMiterlimit: 10,
  width: 960,
  height: 960
}), /*#__PURE__*/React.createElement("rect", {
  x: 667.5,
  y: 667.5,
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0461,
  strokeMiterlimit: 10,
  width: 320,
  height: 320
}), /*#__PURE__*/React.createElement("rect", {
  x: 747.5,
  y: 747.5,
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0461,
  strokeMiterlimit: 10,
  width: 160,
  height: 160
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0461,
  strokeMiterlimit: 10,
  x1: 1327.5,
  y1: 327.5,
  x2: 327.5,
  y2: 1327.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0461,
  strokeMiterlimit: 10,
  x1: 327.5,
  y1: 327.5,
  x2: 1327.5,
  y2: 1327.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeMiterlimit: 10,
  x1: 1067.5,
  y1: 1307.5,
  x2: 1067.5,
  y2: 347.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeMiterlimit: 10,
  x1: 827.5,
  y1: 1307.5,
  x2: 827.5,
  y2: 347.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeMiterlimit: 10,
  x1: 587.5,
  y1: 1307.5,
  x2: 587.5,
  y2: 347.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeMiterlimit: 10,
  x1: 467.5,
  y1: 1307.5,
  x2: 467.5,
  y2: 347.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeMiterlimit: 10,
  x1: 707.5,
  y1: 1307.5,
  x2: 707.5,
  y2: 347.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeMiterlimit: 10,
  x1: 947.5,
  y1: 1307.5,
  x2: 947.5,
  y2: 347.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeMiterlimit: 10,
  x1: 1187.5,
  y1: 1307.5,
  x2: 1187.5,
  y2: 347.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeMiterlimit: 10,
  x1: 1307.5,
  y1: 1067.5,
  x2: 347.5,
  y2: 1067.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeMiterlimit: 10,
  x1: 1307.5,
  y1: 1187.5,
  x2: 347.5,
  y2: 1187.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeMiterlimit: 10,
  x1: 1307.5,
  y1: 947.5,
  x2: 347.5,
  y2: 947.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeMiterlimit: 10,
  x1: 1307.5,
  y1: 707.5,
  x2: 347.5,
  y2: 707.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeMiterlimit: 10,
  x1: 1307.5,
  y1: 467.5,
  x2: 347.5,
  y2: 467.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeMiterlimit: 10,
  x1: 1307.5,
  y1: 587.5,
  x2: 347.5,
  y2: 587.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeMiterlimit: 10,
  x1: 1307.5,
  y1: 827.5,
  x2: 347.5,
  y2: 827.5
}), /*#__PURE__*/React.createElement("rect", {
  x: 387.5,
  y: 387.5,
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0507,
  strokeMiterlimit: 10,
  width: 880,
  height: 880
}), /*#__PURE__*/React.createElement("rect", {
  x: 467.5,
  y: 467.5,
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0415,
  strokeMiterlimit: 10,
  width: 720,
  height: 720
}), /*#__PURE__*/React.createElement("rect", {
  x: 547.5,
  y: 547.5,
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0404,
  strokeMiterlimit: 10,
  width: 560,
  height: 560
}), /*#__PURE__*/React.createElement("rect", {
  x: 627.5,
  y: 627.5,
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0577,
  strokeMiterlimit: 10,
  width: 400,
  height: 400
}), /*#__PURE__*/React.createElement("rect", {
  x: 707.5,
  y: 707.5,
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0346,
  strokeMiterlimit: 10,
  width: 240,
  height: 240
}), /*#__PURE__*/React.createElement("rect", {
  x: 787.5,
  y: 787.5,
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0231,
  strokeMiterlimit: 10,
  width: 80,
  height: 80
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0507,
  strokeMiterlimit: 10,
  x1: 387.5,
  y1: 347.5,
  x2: 387.5,
  y2: 1307.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0507,
  strokeMiterlimit: 10,
  x1: 427.5,
  y1: 347.5,
  x2: 427.5,
  y2: 1307.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0507,
  strokeMiterlimit: 10,
  x1: 507.5,
  y1: 347.5,
  x2: 507.5,
  y2: 1307.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0507,
  strokeMiterlimit: 10,
  x1: 547.5,
  y1: 347.5,
  x2: 547.5,
  y2: 1307.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0507,
  strokeMiterlimit: 10,
  x1: 627.5,
  y1: 347.5,
  x2: 627.5,
  y2: 1307.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0507,
  strokeMiterlimit: 10,
  x1: 667.5,
  y1: 347.5,
  x2: 667.5,
  y2: 1307.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0507,
  strokeMiterlimit: 10,
  x1: 747.5,
  y1: 347.5,
  x2: 747.5,
  y2: 1307.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0507,
  strokeMiterlimit: 10,
  x1: 787.5,
  y1: 347.5,
  x2: 787.5,
  y2: 1307.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0507,
  strokeMiterlimit: 10,
  x1: 867.5,
  y1: 347.5,
  x2: 867.5,
  y2: 1307.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0507,
  strokeMiterlimit: 10,
  x1: 907.5,
  y1: 347.5,
  x2: 907.5,
  y2: 1307.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0507,
  strokeMiterlimit: 10,
  x1: 987.5,
  y1: 347.5,
  x2: 987.5,
  y2: 1307.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0507,
  strokeMiterlimit: 10,
  x1: 1027.5,
  y1: 347.5,
  x2: 1027.5,
  y2: 1307.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0507,
  strokeMiterlimit: 10,
  x1: 1107.5,
  y1: 347.5,
  x2: 1107.5,
  y2: 1307.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0507,
  strokeMiterlimit: 10,
  x1: 1147.5,
  y1: 347.5,
  x2: 1147.5,
  y2: 1307.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0507,
  strokeMiterlimit: 10,
  x1: 1227.5,
  y1: 347.5,
  x2: 1227.5,
  y2: 1307.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0507,
  strokeMiterlimit: 10,
  x1: 1267.5,
  y1: 347.5,
  x2: 1267.5,
  y2: 1307.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0507,
  strokeMiterlimit: 10,
  x1: 1307.5,
  y1: 387.5,
  x2: 347.5,
  y2: 387.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0507,
  strokeMiterlimit: 10,
  x1: 1307.5,
  y1: 427.5,
  x2: 347.5,
  y2: 427.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0507,
  strokeMiterlimit: 10,
  x1: 1307.5,
  y1: 507.5,
  x2: 347.5,
  y2: 507.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0507,
  strokeMiterlimit: 10,
  x1: 1307.5,
  y1: 547.5,
  x2: 347.5,
  y2: 547.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0507,
  strokeMiterlimit: 10,
  x1: 1307.5,
  y1: 627.5,
  x2: 347.5,
  y2: 627.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0507,
  strokeMiterlimit: 10,
  x1: 1307.5,
  y1: 667.5,
  x2: 347.5,
  y2: 667.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0507,
  strokeMiterlimit: 10,
  x1: 1307.5,
  y1: 747.5,
  x2: 347.5,
  y2: 747.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0507,
  strokeMiterlimit: 10,
  x1: 1307.5,
  y1: 787.5,
  x2: 347.5,
  y2: 787.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0507,
  strokeMiterlimit: 10,
  x1: 1307.5,
  y1: 867.5,
  x2: 347.5,
  y2: 867.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0507,
  strokeMiterlimit: 10,
  x1: 1307.5,
  y1: 907.5,
  x2: 347.5,
  y2: 907.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0507,
  strokeMiterlimit: 10,
  x1: 1307.5,
  y1: 987.5,
  x2: 347.5,
  y2: 987.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0507,
  strokeMiterlimit: 10,
  x1: 1307.5,
  y1: 1027.5,
  x2: 347.5,
  y2: 1027.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0507,
  strokeMiterlimit: 10,
  x1: 1307.5,
  y1: 1107.5,
  x2: 347.5,
  y2: 1107.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0507,
  strokeMiterlimit: 10,
  x1: 1307.5,
  y1: 1147.5,
  x2: 347.5,
  y2: 1147.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0507,
  strokeMiterlimit: 10,
  x1: 1307.5,
  y1: 1227.5,
  x2: 347.5,
  y2: 1227.5
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#E3147F",
  strokeWidth: 0.0507,
  strokeMiterlimit: 10,
  x1: 1307.5,
  y1: 1267.5,
  x2: 347.5,
  y2: 1267.5
}), /*#__PURE__*/React.createElement("rect", {
  x: 327.5,
  y: 327.5,
  fill: "none",
  stroke: "#E3147F",
  strokeMiterlimit: 10,
  width: 1000,
  height: 1000
}))));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "espanso"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M1227,519.528h-80c-0.623,0-1.24,0.028-1.853,0.069l-0.001-0.006c0,0,0.234-0.028,0.68-0.035 c-0.379,0.009-9.51,0.05-20.898-6.768c-15.941-9.544-28.921-28.354-37.535-54.394c-14.053-42.485-43.077-73.115-83.935-88.581 c-27.701-10.485-51.722-10.434-56.935-10.281H867c-0.188,0-0.373,0.011-0.561,0.014h-78.798 c-5.213-0.16-29.229-0.207-56.937,10.281c-40.857,15.466-69.882,46.096-83.934,88.58c-8.614,26.04-21.594,44.85-37.537,54.394 c-10.287,6.159-18.725,6.719-20.545,6.765c-0.702-0.076-0.562-0.024-1.526-0.024H587c-15.188,0-27.5,12.312-27.5,27.5 s12.312,27.5,27.5,27.5h0.005c0.257,0.003,0.54,0.006,0.848,0.006c14.028-0.001,80.124-5.122,111.135-98.868 c8.595-25.984,25.261-44.076,49.536-53.772c18.951-7.57,36.079-7.422,37.466-7.385c0.475,0.027,0.654,0.023,1.173,0.023h80 c0.188,0,0.373-0.01,0.56-0.014H947c0.424,0,0.848-0.01,1.27-0.03c0.162-0.009,16.794-0.414,35.719,6.749 c25.174,9.529,42.396,27.836,51.188,54.416c31.013,93.751,97.111,98.866,111.135,98.866c0.273,0,0.511-0.003,0.744-0.006H1227 c28.949,0,52.5,23.55,52.5,52.497v79.978c0,15.188,12.312,27.5,27.5,27.5s27.5-12.312,27.5-27.5v-79.978 C1334.5,567.751,1286.275,519.528,1227,519.528z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1307,879.502c-15.188,0-27.5,12.312-27.5,27.5v280.002c0,28.947-23.551,52.497-52.5,52.497H427 c-28.949,0-52.5-23.55-52.5-52.497V627.024c0-28.947,23.551-52.497,52.5-52.497c0.002,0,0.004,0,0.006,0c0.001,0,0.003,0,0.005,0 c15.188,0,27.5-12.312,27.5-27.5v-52.497h92.5c15.188,0,27.5-12.312,27.5-27.5s-12.312-27.5-27.5-27.5h-120 c-15.188,0-27.5,12.312-27.5,27.5v56.064C353.51,535.272,319.5,577.249,319.5,627.024v559.979 c0,59.273,48.224,107.497,107.5,107.497h800c59.275,0,107.5-48.223,107.5-107.497V907.001 C1334.5,891.813,1322.188,879.502,1307,879.502z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M947,574.528c15.188,0,27.5-12.312,27.5-27.5s-12.312-27.5-27.5-27.5H787c-15.188,0-27.5,12.312-27.5,27.5 s12.312,27.5,27.5,27.5H947z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M600,907.395c0,60.766,23.664,117.895,66.633,160.863c42.97,42.967,100.1,66.631,160.867,66.631 s117.897-23.664,160.866-66.631c42.97-42.968,66.634-100.097,66.634-160.863s-23.664-117.895-66.634-160.863 C945.397,703.564,888.268,679.9,827.5,679.9s-117.897,23.664-160.867,66.631C623.664,789.5,600,846.628,600,907.395z M827.5,734.9 c95.117,0,172.5,77.38,172.5,172.494s-77.383,172.494-172.5,172.494S655,1002.508,655,907.395S732.383,734.9,827.5,734.9z"
})));

var SvgCamera = function SvgCamera(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "50px",
    height: "50px",
    viewBox: "0 0 1655 1655",
    enableBackground: "new 0 0 1655 1655",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCamera, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/camera.8bbc2e70.svg";
export { ForwardRef as ReactComponent };